import { render } from "./CabecalhoNota.vue?vue&type=template&id=fedaeebc&scoped=true"
import script from "./CabecalhoNota.vue?vue&type=script&lang=js"
export * from "./CabecalhoNota.vue?vue&type=script&lang=js"

import "./CabecalhoNota.vue?vue&type=style&index=0&id=fedaeebc&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fedaeebc"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QInput,QIcon,QPopupProxy,QDate,QBtn});qInstall(script, 'directives', {ClosePopup});
